export const FORMULE_LABELS = {
  total_klub: 'Total Klub',
  klub_premium: 'Klub Premium',
  klub_premium_sans_site: 'Klub Premium sans site',
  klub_ce: 'Klub CE',
  klub_ce_sans_site: 'Klub CE sans site',
  total_klub_ce_only: 'Sans site',
};

export const STATUT_LABELS = {
  actif: 'Actif',
  en_cours: 'En cours',
  signe_sans_rdv: 'Signé sans RDV',
  resilie: 'Résilié',
};

/** Choix proposés à la saisie. « Signé sans RDV » n’est plus une phase, mais reste affiché s’il est déjà le statut. */
export function statutSelectOptions(currentStatut = '') {
  return Object.entries(STATUT_LABELS).filter(([code]) => code !== 'signe_sans_rdv' || code === currentStatut);
}

export const MATCH_STATUS_LABELS = {
  pending: 'En attente',
  matched: 'À valider',
  validated: 'Validé',
  rejected: 'Rejeté',
};

export const WORKFLOW_STATUS_LABELS = {
  pending: 'En attente',
  ok: 'OK',
  na: 'N/A',
  blocked: 'Bloqué',
};

export const LISTING_DONNE_LABELS = {
  oui: 'Oui',
  en_attente: 'En attente',
  refuse: 'Refus',
};

export const ACCES_CARTES_LABELS = {
  livrees: 'Cartes livrées',
  en_attente: 'En attente',
  non_livrees: 'Non livrées',
  refus: 'Refus',
  partiel: 'Partiellement livrées',
};

export const CE_DASHBOARD_ETAPES = [
  { code: 'refus', label: 'Refus', hint: 'Listing ou cartes refusés', icon: 'mdi:cancel', color: 'danger' },
  { code: 'attente_listing', label: 'Attente listing', hint: 'Listing à réclamer', icon: 'mdi:clock-outline', color: 'warning' },
  { code: 'listing_recu', label: 'Listing reçu', hint: 'Cartes à fabriquer', icon: 'mdi:file-check-outline', color: 'info' },
  { code: 'cartes_pretes', label: 'Cartes prêtes', hint: 'Carte à délivrer', icon: 'mdi:card-account-details-outline', color: 'primary' },
  { code: 'cartes_remises', label: 'Cartes remises', hint: 'Accès validé', icon: 'mdi:check-decagram-outline', color: 'success' },
];

export const CE_ETAPE_FILTER_OPTIONS = CE_DASHBOARD_ETAPES.map((step) => ({
  value: step.code,
  label: step.label,
}));

export function ceDashboardEtape(ce) {
  const listing = ce?.listing_donne ?? null;
  const cartes = ce?.acces_cartes ?? null;
  if (listing === 'refuse' || cartes === 'refus') return 'refus';
  if (cartes === 'livrees' || cartes === 'partiel') return 'cartes_remises';
  if (cartes === 'non_livrees') return 'cartes_pretes';
  if (listing === 'oui') return 'listing_recu';
  return 'attente_listing';
}

export const CE_CHECK_COLUMNS = [
  { code: 'refus', label: 'Refus', title: 'Refus' },
  { code: 'listing_recu', label: 'Reçu', title: 'Listing reçu' },
  { code: 'cartes_pretes', label: 'Prêtes', title: 'Cartes prêtes' },
  { code: 'cartes_remises', label: 'Remises', title: 'Cartes remises' },
];

export function ceStepChecked(ce, code) {
  const etape = ceDashboardEtape(ce);
  if (code === 'refus') return etape === 'refus';
  if (code === 'listing_recu') return etape === 'listing_recu' || etape === 'cartes_pretes' || etape === 'cartes_remises';
  if (code === 'cartes_pretes') return etape === 'cartes_pretes' || etape === 'cartes_remises';
  if (code === 'cartes_remises') return etape === 'cartes_remises';
  return false;
}

export function ceCheckPatch(ce, code, checked) {
  const cartes = ce?.acces_cartes ?? null;
  if (code === 'refus') {
    if (checked) return { listing_donne: 'refuse' };
    return {
      listing_donne: 'en_attente',
      acces_cartes: cartes === 'refus' ? 'en_attente' : cartes,
    };
  }
  if (code === 'listing_recu') {
    if (checked) {
      return {
        listing_donne: 'oui',
        acces_cartes: cartes === 'refus' ? 'en_attente' : cartes,
      };
    }
    const later = cartes === 'livrees' || cartes === 'partiel' || cartes === 'non_livrees' || cartes === 'refus';
    return { listing_donne: 'en_attente', acces_cartes: later ? 'en_attente' : cartes };
  }
  if (code === 'cartes_pretes') {
    if (checked) return { listing_donne: 'oui', acces_cartes: 'non_livrees' };
    return { acces_cartes: 'en_attente' };
  }
  if (code === 'cartes_remises') {
    if (checked) return { listing_donne: 'oui', acces_cartes: 'livrees' };
    return { acces_cartes: 'non_livrees' };
  }
  return {};
}

export const SALARIES_RANGE_OPTIONS = [
  { value: '1', label: '1 salarié', min: 1, max: 1 },
  { value: '2-10', label: '2 à 10', min: 2, max: 10 },
  { value: '11-20', label: '11 à 20', min: 11, max: 20 },
  { value: '21-48', label: '21 à 48', min: 21, max: 48 },
  { value: '49+', label: '49 et plus', min: 49, max: null },
];

export function matchesSalariesRange(nombreSalaries, rangeValues) {
  if (!rangeValues?.length) return true;
  const n = nombreSalaries == null || nombreSalaries === '' ? null : Number(nombreSalaries);
  return rangeValues.some((code) => {
    const range = SALARIES_RANGE_OPTIONS.find((option) => option.value === code);
    if (!range) return false;
    if (n == null || Number.isNaN(n)) return false;
    if (range.min != null && n < range.min) return false;
    if (range.max != null && n > range.max) return false;
    return true;
  });
}

export function toInputDate(value) {
  if (!value) return '';
  if (typeof value === 'string' && value.length >= 10) return value.slice(0, 10);
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('fr-FR');
}

export function matchStatusBadgeClass(status) {
  switch (status) {
    case 'validated': return 'bg-success-focus text-success-main';
    case 'matched': return 'bg-warning-focus text-warning-main';
    case 'rejected': return 'bg-danger-focus text-danger-main';
    default: return 'bg-neutral-200 text-secondary-light';
  }
}

export function listingDonneBadgeClass(value) {
  switch (value) {
    case 'oui': return 'bg-success-focus text-success-main';
    case 'en_attente': return 'bg-warning-focus text-warning-main';
    case 'refuse': return 'bg-danger-focus text-danger-main';
    default: return 'bg-neutral-200 text-secondary-light';
  }
}

export function accesCartesBadgeClass(value) {
  switch (value) {
    case 'livrees': return 'bg-success-focus text-success-main';
    case 'en_attente': return 'bg-warning-focus text-warning-main';
    case 'partiel': return 'bg-info-focus text-info-main';
    case 'non_livrees': return 'bg-neutral-200 text-secondary-light';
    case 'refus': return 'bg-danger-focus text-danger-main';
    default: return 'bg-neutral-200 text-secondary-light';
  }
}

export function statutBadgeClass(statut) {
  switch (statut) {
    case 'actif': return 'bg-success-focus text-success-main';
    case 'en_cours': return 'bg-warning-focus text-warning-main';
    case 'signe_sans_rdv': return 'bg-info-focus text-info-main';
    case 'resilie': return 'bg-danger-focus text-danger-main';
    default: return 'bg-neutral-200 text-secondary-light';
  }
}

export function workflowStatusDotClass(status) {
  switch (status) {
    case 'ok': return 'kf-step-dot--ok';
    case 'pending': return 'kf-step-dot--pending';
    case 'blocked': return 'kf-step-dot--blocked';
    case 'na': return 'kf-step-dot--na';
    default: return 'kf-step-dot--pending';
  }
}

export function workflowStatusBadgeVariant(status) {
  switch (status) {
    case 'ok': return 'success';
    case 'blocked': return 'danger';
    case 'na': return 'neutral';
    default: return 'warning';
  }
}

export function workflowStatusTooltip(status) {
  return WORKFLOW_STATUS_LABELS[status] ?? status;
}
